import React from 'react';
import Component from '../MgyComponent';
import { Button } from '@progress/kendo-react-buttons';

export default function MgyButton({children, className, primary, label, ...rest}) {
    return (
    <Component tpl = { Button }
               primary = {primary}
               className = {"mgy-button " + (primary ? " mgy-primary-button ": "") + (className || '') }
               {...rest}>
        { label || children }
    </Component>);
};
